export default __webpack_public_path__ + "assets/images/50b70247c9dbaf599c313efcfe85cda9.svg";